<template>
  <div class="row mx-0 me-0 p-0 justify-content-center " id="us">
    <div class="col-xl-7 col-lg-7 col-md-11 col-sm-12 text-white shadow bg-green p-0 border-radius  ">
      <div class="row m-2 pb-3 pt-3  bg-white border-radius">
        <div class="col-xl-8 col-lg-8 col-md-11 col-sm-12 p-2">
          <h6 class="text-blue"><i class="fas fa-ellipsis-v  text-red "></i>  ارتباط با واحد تحصیلات تکمیلی بنیاد ایران شناسی</h6>
          <div class="d-flex flex-wrap justify-content-start">
            <span class="text-blue ml-4">تلفن: 88608813-021</span>
            <span class="text-blue">Email:  education.iranology@gmail.com</span>
          </div>
          <p class="text-blue small mt-1"> تهران ، بزرگراه همت ، پل شیخ بهایی ، خیابان شیخ بهایی جنوبی ، شهرک والفجر ، خیابان ایران شناسی </p>
        </div>
      </div>
    </div>
    <div class="col-xl-11 col-lg-11 col-md-11 col-sm12 ">
      <div dir="ltr" class="text-center text-blue rahBottom "> <small class="text-blue small ">
        Responsive Web page : </small>100%<small class="me-2 mx-2">|</small>Design Web : Information Technology Department <small class="me-2 mx-2">|</small>April , 2021
        <img class="pb-1" src="../assets/M.svg" alt="Mohammad Rahimi Angiz">
      </div>
    </div>
  </div>

</template>

<script>
export default {
name: "Contact"
}
</script>

<style scoped lang="scss">
@import "../assets/scss/color";
//.bg{
//  padding-bottom: 8rem;
//  background: url("../assets/image/footer.png") center bottom no-repeat ;
//  background-color: $blue;
//}



ul li{
  padding-bottom: .4rem;
}
ul li::before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: $green; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-right: -1rem; /* Also needed for space (tweak if needed) */
  position: absolute;
  top:3px;
}

.rahBottom {
  //bottom: 1.1rem;
  font-size: .7rem;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (min-width: 980px) {
  .rahBorder{
    //border-left: 1px solid $green;
  }
  .rahLine::after {
    content: "";
    position: absolute;
    top: -3px;
    right: 1px;
    width: 75px;
    height: 88%;
    border-top: 3px dotted #00ded3;
    border-right: 3px dotted #00ded3;
    border-radius: 0 20px 0 0;
  }
  .rahLine::before {
    content: "";
    position: absolute;
    top: -41px;
    right: 1px;
    width: 57px;
    height: 94%;
    border-top: 3px solid #00ded3;
    border-right: 3px solid #00ded3;
    border-radius: 0 20px 0 0;
  }
}


.rahENamad {
  border-radius: 1rem;
  border: 1px solid $green ;
  padding: 10px;
  height: 110px;
}
</style>